import { ref, readonly } from "vue";
import { getResizeImage } from "@/core/api/graphql/catalog";
import { Logger } from "@/core/utilities";
import type { QueryResizeImageArgs } from "@/core/api/graphql/types";

export function useResizeImage() {
  const loading = ref(true);

  async function fetchResizeImage(params: QueryResizeImageArgs) {
    loading.value = true;
    try {
      const result = await getResizeImage(params);

      return result;
    } catch (e) {
      Logger.error("useResizeImage.fetchRelatedProducts", e);
      throw e;
    } finally {
      loading.value = false;
    }
  }

  return {
    fetchResizeImage,
    loading: readonly(loading),
  };
}
